import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {
  EMPLOYEE_TICKET,
  EMPLOYEE_TICKET_DETAILS,
  EMPLOYEE_STATUS,
  EMPLOYEE_FILTER,
} from './type';

export const fetchEmTicket = (filterData = null, page = 1) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null
      ? `${Config.maintenance.employeeTicketsList}?page=${page}`
      : `${Config.maintenance.employeeTicketsList}?status=${filterData.status}&site_no=${filterData.site_no}&client_name=${filterData.client_name}&assignee_id=${filterData.assignee_ids}&page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: EMPLOYEE_TICKET,
      payload: data.response.data,
    });
    return true;
  }
};

export const fetchEmTicketDetails = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.viewEmployeeTickets}?em_ticket_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: EMPLOYEE_TICKET_DETAILS,
      payload: data.response.data,
    });
    return true;
  }
};

export const postUpdateEMStatus = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.emUpdateStatus}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const postTicketAssignment = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.emAssignment}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const postEmployeeRemark = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.postEmployeeRemark}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const fetchEmTicketStatus = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.emStatus}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: EMPLOYEE_STATUS,
      payload: data.response.data,
    });
    return true;
  }
};

export const getEmployeeFilterDropDown = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.emSitesFilters}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: EMPLOYEE_FILTER,
      payload: data.response.data,
    });
    return true;
  }
};
